// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__1MlNw","tippy-box":"Tooltip_tippy-box__1jGSe","tippyBox":"Tooltip_tippy-box__1jGSe"};